export const KV_NAMESPACE_BINDING = "daily_arxiv";

export const VISIT_COUNT_KEY = "visitCount";

export const VISIT_COUNT_ENDPOINT = "/api/visit-count";
